import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = ["aria-expanded", "disabled"]
const _hoisted_3 = { class: "mr-auto min-w-0 flex-1 truncate whitespace-nowrap text-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "top-dropdown scrollbar-hide absolute right-0 z-[2700] mt-2 min-w-[8rem] overflow-y-auto rounded-lg border border-concrete-300 bg-white py-1 shadow-xl"
}
const _hoisted_6 = ["onClick"]

import { ref, computed } from "vue";
import { storeToRefs } from "pinia";

import {
	LOCATION_DISTANCE_PRESETS,
	type LocationDistancePreset,
} from "~/js/composables/mapbox-geocoding";
import { useLocationsStore } from "~/js/store/locations";

import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";

interface Props {
	label: string;
	loading: boolean;
	utilities?: string;
	/** Borderless control for use inside the combined search pill. */
	embedded?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLocationDistance',
  props: {
    label: {},
    loading: { type: Boolean },
    utilities: { default: "" },
    embedded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

const locationsStore = useLocationsStore();
const { searchPlace, radiusKm } = storeToRefs(locationsStore);
const expanded = ref(false);

const disabled = computed(() => !searchPlace.value);

const selectedLabel = computed(() => {
	if (!radiusKm.value) {
		return props.label;
	}

	return `+${radiusKm.value} km`;
});

const setRadius = (km: LocationDistancePreset) => {
	locationsStore.setRadius(km);
	expanded.value = false;
};

const toggle = () => {
	if (disabled.value) {
		return;
	}

	expanded.value = !expanded.value;
};

const onClose = () => {
	expanded.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(['relative shrink-0', expanded.value ? 'z-[2600]' : '', __props.utilities])
  }, [
    _createElementVNode("legend", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("button", {
      class: _normalizeClass([
				'inline-flex min-w-0 items-center px-4 py-2 print:hidden',
				__props.embedded
					? 'w-[7.5rem] max-w-[7.5rem] rounded-full border border-concrete-500 bg-white'
					: 'min-w-[7rem] rounded-full border border-gray-300 bg-white',
				'font-primary text-sm text-black',
				'focus:outline-none focus:ring-4 focus:ring-celestial-500',
				disabled.value ? 'cursor-not-allowed opacity-50' : '',
			]),
      type: "button",
      "aria-expanded": expanded.value,
      disabled: disabled.value,
      onClick: toggle
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(selectedLabel.value), 1),
      _createElementVNode("span", {
        class: _normalizeClass([
					'inline-flex shrink-0 transform-gpu items-center justify-end transition-transform duration-200 ease-in-out',
					expanded.value ? 'rotate-180' : 'rotate-0',
				])
      }, [
        (!__props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "far fa-chevron-down" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass([__props.loading ? 'block' : 'hidden', 'text-viridian-500'])
        }, [
          _createVNode(SvgLoader)
        ], 2)
      ], 2)
    ], 10, _hoisted_2),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LOCATION_DISTANCE_PRESETS), (preset) => {
            return (_openBlock(), _createElementBlock("button", {
              key: preset,
              type: "button",
              class: _normalizeClass([
					'inline-flex w-full items-center px-4 py-2',
					'text-left font-primary text-sm text-black',
					_unref(radiusKm) === preset ? 'bg-concrete-200 font-semibold' : 'hover:bg-concrete-200',
				]),
              onClick: ($event: any) => (setRadius(preset))
            }, " +" + _toDisplayString(preset) + " km ", 11, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_away, onClose]
  ])
}
}

})